import { useSelector } from 'react-redux';
import { PropertySettingType, StudentSelectionMode } from '@common/entities';
import { RootState } from 'state/store';

const BULK_UNIT_ASSIGNMENT_SETTING_VALUE = '1';

const selectStudentAvailabilityLeaseBy = (state: RootState): unknown =>
  state.propertySettings.propertySettings.find(
    (setting) => setting.settingType === PropertySettingType.StudentAvailabilityLeaseBy,
  )?.value;

export function getStudentSelectionMode(settingValue: unknown): StudentSelectionMode {
  if (settingValue === undefined) return StudentSelectionMode.BULK_UNIT_ASSIGNMENT;

  return settingValue === BULK_UNIT_ASSIGNMENT_SETTING_VALUE
    ? StudentSelectionMode.BULK_UNIT_ASSIGNMENT
    : StudentSelectionMode.STUDENT_UNIT_SELECTION;
}

/**
 * Returns the student selection mode configured for the current property.
 * Properties without this setting use bulk unit assignment for backwards compatibility.
 */
export function useStudentSelectionMode(): StudentSelectionMode {
  const settingValue = useSelector(selectStudentAvailabilityLeaseBy);

  return getStudentSelectionMode(settingValue);
}
